module.exports = __webpack_public_path__ + "img/homepage-download-app.f6a1bc37.png";